<template>
  <div id="app" :style="'background-image: ' + backgroundImage +'; --font-size: ' + fontSize + ';' ">
    <router-view v-if="configLoaded" />
    <the-loader v-else></the-loader>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TheLoader from "./components/TheLoader.vue";

export default {
  name: "App",
  components: {
    TheLoader
  },
  computed: {
    ...mapState({
      fontSize: (state) => state.style.fontSize,
      configLoaded: (state) => state.business.configLoaded,
      backgroundImage: (state) => "url(" + state.business.sysConfig.bgUrl + ")",
    }),
  },
  methods: {},
  data() {
    return {
      
    };
  },
  async mounted() {
  },
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

::-webkit-scrollbar {
  width: 5px;
  background: #fff;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #aaa;
}

html,
body {
  height: 100%;
  width: 100%;
  font-size: 14px;
  background-color: #f0f5ff;
  font-family: Microsoft YaHei;
}

#app {
  height: 100%;
  width: 100%;
  /* display: flex;
  align-items: center;
  justify-content: center; */

  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: url("~@img/bg.png") no-repeat;
  background-size: 100% 100%;
  background-position: 0 0;
}
</style>
